import SalesPitchCalculatorGradient from '@/common/components/sales-pitch-calculator-gradient';
import Spacer from '@/common/components/spacer';
import FlexcarTextLogo from '@/icons/flexcar-text-logo';

interface CalculatorBrandingProps {
  showSavingsCalculatorV2: boolean;
}

export default function CalculatorBranding({
  showSavingsCalculatorV2,
}: CalculatorBrandingProps) {
  return (
    <div className="absolute right-0 top-0">
      {!showSavingsCalculatorV2 ? (
        <div className="relative z-1 flex flex-col pb-6 pl-6 pr-4 pt-4">
          <div className="right-0 top-0 ml-auto h-3 w-16">
            <FlexcarTextLogo />
          </div>
          <Spacer variant="height8" />
          <h1 className="ml-auto mt-[-2px] text-right text-sm leading-[19px] text-flexcar-neutral100">
            Savings Calculator
          </h1>
        </div>
      ) : null}
      <div className="absolute right-0 top-0 h-[238px] w-[390px] flex-shrink-0 overflow-hidden bg-flexcar-neutral100/5">
        <SalesPitchCalculatorGradient />
      </div>
    </div>
  );
}
